import CSSLengthOriginal from 'css-length';
import { isArray } from 'lodash';

export default class CSSLength extends CSSLengthOriginal {
    // wrapper constructor to fail safely when property cant be matched
    constructor(raw, options = {}) {
        if (raw) {
            const check = raw.match(/^([+-]?[0-9\.]+)(cm|em|in|mm|pc|%|pt|px|rem)$/);
            if(!(check && isArray(check) && check.length >= 3)) {
                super('0px', options);
            } else {
                super(raw, options);
            }
        } else {
            super('0px', options);
        }
    }
}



// WEBPACK FOOTER //
// ./lib/css-property-parser/CSSLength.js